module.exports = __webpack_public_path__ + "media/images/pc/stores/funabashi/access/chiba_funabashi_point1_3-4413ff333761cbbcf40335d80f2c83de.jpg";